import { Spin } from 'antd';
import { useLazyGetFaqQuery } from 'app/services/edpApiV1/faq';
import { useAppDispatch, useAppSelector } from 'app/store';
import { categoryActions } from 'entities/faq/model/category';
import { viewerModel } from 'entities/viewer';
import FaqTable from 'features/tables/faqTable';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaqStatuses, SearchKeysFaq } from 'shared/enums/FAQ';
import { dataForFaqTable } from 'shared/helpers/utils';
import { TFaqColumns, TFaqGetResponsePaginated, TSearchDataFaq } from 'shared/types/faq.types';

const FaqPublicated = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { search } = useAppSelector(state => state.entities.search);
  const [getFaqQueryRequest, result] = useLazyGetFaqQuery();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchData, setSearchData] = useState<TSearchDataFaq>({ key: SearchKeysFaq.SEARCH_NAME, value: '' });

  useEffect(() => {
    getFaqQueryRequest({
      size: currentSize,
      page: currentPage,
      type: FaqStatuses.PUBLICATED,
      [searchData.key]: searchData.value ? searchData.value : undefined,
    });
  }, [currentPage, currentSize, getFaqQueryRequest]);

  useEffect(() => {
    dispatch(categoryActions.setIsCategoryTab(false));
  }, []);

  const onClickToRow = (id: number) => {
    navigate(`/faq/info/${id}`);
  };

  const onSearch = (data: string | null, key: SearchKeysFaq) => {
    setSearchData({ key, value: data || '' });
    getFaqQueryRequest({
      size: currentSize,
      page: currentPage,
      type: FaqStatuses.PUBLICATED,
      [key]: data ? data : undefined,
    });
  };

  const columns: TFaqColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Автор',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Категория',
      dataIndex: 'category',
      key: 'category',
    },
  ];

  return (
    <Spin spinning={result.isFetching || result.isLoading}>
      {result.data ? (
        <FaqTable
          dataSource={dataForFaqTable(result?.data.data || [])}
          columns={columns}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentPage={setCurrentPage}
          setCurrentSize={setCurrentSize}
          total={result?.data.pagination.total}
          onclickToRow={onClickToRow}
          onSearch={onSearch}
        />
      ) : null}
    </Spin>
  );
};

export default FaqPublicated;
